export default __webpack_public_path__ + "static/media/sm_popsicle.b9ae2d50.gif";